<ion-grid>
  <ion-row>
    <ion-col size="8">
      <ion-text><h3>All Events</h3></ion-text>
    </ion-col>
    <ion-col size="4" class="ion-text-right">
      <ion-button color="white" class="disable-default-style" (click)="refresh()">
        <ion-icon name="refresh-circle-outline"></ion-icon>
      </ion-button>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      @if (loading) {
        <ion-skeleton-text [animated]="true"></ion-skeleton-text>
      }

      @if (!loading && !loaded) {
        <ion-item lines="none">
          <ion-icon name="cloud-offline-outline" slot="start"></ion-icon>
          Events not loaded. Tap refresh to load.
        </ion-item>
      }

      @if (!loading && loaded && historyLogs?.length === 0) {
        <ion-item lines="none">
          <ion-icon name="hourglass-outline" slot="start"></ion-icon>
          No events yet
        </ion-item>
      }

      @if (historyLogs?.length > 0 && !loading) {
        <ion-list>
          @for (log of historyLogs; track log) {
            <ion-item lines="none">
              <ion-icon [name]="log.icon" slot="start"></ion-icon>
              <ion-grid>
                <ion-row class="date">
                  {{ log.createdAt | date : "medium" }}
                </ion-row>
                <ion-row>
                  <span class="details">
                    {{ userToString(log.fullUser) }} {{ historyToString(log) }}
                    {{ log.fullDriver ? driverToString(log.fullDriver) : "" }}
                  </span>
                </ion-row>
              </ion-grid>
              @if (isOrderHistory(log) && log.picture) {
                <rc-clickable-thumbnail
                  description="Picture added on {{ log.createdAt | date : 'mediumDate' }}"
                  [src]="log.picture"
                slot="end"></rc-clickable-thumbnail>
              }
            </ion-item>
          }
        </ion-list>
      }
    </ion-col>
  </ion-row>
</ion-grid>
